import {useQuery} from '@tanstack/react-query';
import {useMemo} from 'react';
import {fetchConversations} from '../message';
import {QUERY_KEYS} from '../../utils/queryKeys';

export function useConversationsUnreadCount(): {numberOfUnreadMessages: number | undefined} {
    const conversationsData = useQuery(QUERY_KEYS.conversation.lists(), () => fetchConversations({pageSize: 20, pageNumber: 1}), {
        refetchInterval: 5000,
    });

    const numberOfUnreadMessages = useMemo(() => {
        return conversationsData.data?.content.reduce((acc, conversation) => {
            return acc + (conversation.numberOfUnseen || 0);
        }, 0);
    }, [conversationsData.data?.content]);

    return {numberOfUnreadMessages};
}
